export default __webpack_public_path__ + "static/media/ceshi-hover.83bcc88c.svg";